var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.31 4.395C3.03 5.81 4.19 6.965 5.605 7.69L6.705 6.59C6.84 6.455 7.04 6.41 7.215 6.47C7.775 6.655 8.38 6.755 9 6.755C9.275 6.755 9.5 6.98 9.5 7.255V9C9.5 9.275 9.275 9.5 9 9.5C4.305 9.5 0.5 5.695 0.5 1C0.5 0.725 0.725 0.5 1 0.5H2.75C3.025 0.5 3.25 0.725 3.25 1C3.25 1.625 3.35 2.225 3.535 2.785C3.59 2.96 3.55 3.155 3.41 3.295L2.31 4.395Z",
    fill: "#255986"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneBlue);
export default __webpack_public_path__ + "static/media/phone-blue.c4739cb90cba983d634bccb5ae7eaf83.svg";
export { ForwardRef as ReactComponent };